import { TileIndex } from "../../types";

export const LEVEL_2: TileIndex[][] = [
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 0, 0, 0, 0, 9, 0, 0, 0, 4, 8, 3, 0, 0, 10, 2, 0, 0, 15, 1],
  [1, 0, 12, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 2, 1],
  [1, 0, 0, 0, 5, 9, 3, 0, 2, 0, 8, 0, 2, 6, 10, 3, 0, 0, 2, 1],
  [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 2, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
];
